import {get, postJ} from "@/request"
import {IPage, IPageRes} from "@/apis/page";
import {IAppletBanner} from "@/apis/applet/banner/types";

export const plantationQueryApi = (params: IPage) => get<IPageRes<any[]>>("/card/plantation/query", params)

export const plantationCreateApi = (data: Partial<any>) => postJ("/card/plantation/create", data)

export const plantationDetailApi = (id: string) => get<any>("/card/plantation/detail/" + id)

export const plantationModifyApi = (data: Partial<any>) => postJ("/card/plantation/modify", data)

export const fruitTreeQueryApi = (params: IPage) => get<IPageRes<any[]>>("/card/fruit/tree/query", params)

export const fruitTreeCreateApi = (data: Partial<any>) => postJ("/card/fruit/tree/create", data)

export const fruitTreeModifyApi = (data: Partial<any>) => postJ("/card/fruit/tree/modify", data)

export const fruitTreeDetailApi = (id: string) => get<any>("/card/fruit/tree/detail/" + id)

export const getFruitTreeListApi = (params: any) => get<any>("/card/fruit/tree/getList", params)

export const getPlantationListApi = (params: any) => get<any>("/card/plantation/getList", params)

export const harvestQueryApi = (params: IPage) => get<IPageRes<any[]>>("/card/harvest/query", params)

export const harvestCreateApi = (data: Partial<any>) => postJ("/card/harvest/create", data)

export const procurementCheckinApi = (data: Partial<any>) => postJ("/card/harvest/procurement/checkin", data)

export const checkoutApi = (data: Partial<any>) => postJ("/card/harvest/checkout", data)

export const checkoutPageApi = (params: IPage) => get<IPageRes<any[]>>("/card/fruit/tree/checkout/query", params)

export const checkinPageApi = (params: IPage) => get<IPageRes<any[]>>("/card/fruit/tree/checkin/query", params)

export const plantationJonQueryApi = (params: IPage) => get<IPageRes<any[]>>("/card/plantation/job/query", params)

export const plantationJobCreateApi = (data: Partial<any>) => postJ("/card/plantation/job/create", data)

export const sourceNodeQueryApi = (data: Partial<any>) => get<IPageRes<any[]>>("/card/fruit/tree/source/node/query", data)

export const fruitTreeSourceQueryApi = (params: IPage) => get<IPageRes<any[]>>("/card/fruit/tree/source/query", params)

export const fruitTreeSourceCreateApi = (data: Partial<any>) => postJ("/card/fruit/tree/source/create", data)

export const fruitTreeSourceModifyApi = (data: Partial<any>) => postJ("/card/fruit/tree/source/modify", data)

export const fruitTreeSourceDetailApi = (id: string) => get<any>("/card/fruit/tree/source/detail/" + id)

export const fruitTreeSourceRemoveApi = (id: string) => get<any>("/card/fruit/tree/source/remove/" + id)
